export class ConsultaGarantias{
    idGarantia: number;
    idCredito: number;

    constructor (idGarantia: number, idCredito: number ){
     this.idGarantia = idGarantia;
     this.idCredito = idCredito;
    }
}